import React, { useEffect, useState } from 'react';
import { useHook as equipmentHook } from './useHook';
import { useNavigate, useParams } from 'react-router-dom';
import { Unauthorized } from '../../../components';
import { Button } from '@mui/material';
import { useAlert } from '../../../components/Notification';
import { useHook as globalAlertHook } from '../alert/useHook';
interface EquipmentAlertProps {
  equipmentDetailsData: any;
  refreshKey?: any;
}

const EquipmentAlert: React.FC<EquipmentAlertProps> = ({
  equipmentDetailsData,
  refreshKey,
}) => {
  const [alertList, setAlertList] = useState<any>(null);
  const { fetchAlertList } = equipmentHook();
  const { id } = useParams();
  const navigate = useNavigate();
  const showAlert = useAlert();
  const { markAsRead } = globalAlertHook();

  //Get Alert List
  const getreadUnitParameter = async () => {
    await fetchAlertList({ unitID: id })
      .then((response) => {
        setAlertList(response);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //dateformat
  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12; // Convert 0 hours to 12 for AM/PM format
    const formattedHours = hours.toString();

    return `${day} ${month} ${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  }

  useEffect(() => {
    getreadUnitParameter();
  }, [refreshKey]);

  // markAsRead
  const handleMarkAsRead = async (id: string[], action: boolean) => {
    const payload = {
      alertIDs: id,
      action,
    };
    await markAsRead(payload).then((res) => {
      if (res) {
        action
          ? showAlert('Changed to Read Successfully', 'success')
          : showAlert('Changed to Unread Successfully', 'success');
      }
    });
    await getreadUnitParameter();
  };

  return Object.keys(equipmentDetailsData).length > 0 &&
    alertList?.length > 0 ? (
    <section className="equipment_information">
      <div className="equipment_information_heading">
        <h5>Alerts</h5>
        {equipmentDetailsData?.subscriptionStatus === 'active' && (
          <Button onClick={() => navigate('/alert', { state: id })}>
            View All
          </Button>
        )}
      </div>
      {equipmentDetailsData?.subscriptionStatus === 'active' ? (
        <div className="equipment_information-content">
          {alertList?.slice(0, 5)?.map((alertData: any, index: number) => (
            <div
              key={index}
              className={
                alertData?.isUnread
                  ? 'equipment_alert alert_body_unread'
                  : 'equipment_alert '
              }
            >
              <div className="equipment_alert-heading">
                <h5>{alertData?.title}</h5>
                <div className="equipment_alert-read_unread">
                  <h6>Created date : {formatDate(alertData?.createdAt)}</h6>
                  {/* <div
                    className={`user_management_status-data ${alertData?.isUnread ? 'inactive' : 'active'}`}
                  >
                    {alertData?.isUnread ? 'Unread' : 'Read'}
                  </div> */}
                  <div className="markus_read_unread-btn">
                    <Button
                      onClick={() =>
                        handleMarkAsRead(
                          [alertData?.alertID],
                          alertData?.isUnread,
                        )
                      }
                    >
                      {alertData?.isUnread ? 'Mark as read' : 'Mark as Unread'}
                    </Button>
                  </div>
                </div>
              </div>
              <p>{alertData?.description}</p>
            </div>
          ))}
        </div>
      ) : (
        // <p className="edit_access_error">
        //   * You cannot view parameter value. Please contact to your admin
        //   partner.
        // </p>
        <Unauthorized
          message={
            'Your subscription is inactive. Please activate it to view the details.'
          }
        />
      )}
    </section>
  ) : (
    <></>
  );
};

const MemoizedComponent = React.memo(EquipmentAlert);
export default MemoizedComponent;
